import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=321b4474&scoped=true"
import script from "./logistics.vue?vue&type=script&lang=ts"
export * from "./logistics.vue?vue&type=script&lang=ts"
import style0 from "./logistics.vue?vue&type=style&index=0&id=321b4474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b4474",
  null
  
)

export default component.exports